module.exports = "<div class=\"js-remove user-avatar-editor__empty\">X</div> <div class=\"js-image user-avatar-editor\"> <div class=\"js-initials user-avatar-editor__txt\"></div> <div class=\"js-tooltip user-avatar-editor__btn\"><span class=user-avatar-editor-btn>{{localize 'CORE.FORM.EDITORS.AVATAR.CHANGE'}}</span></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/avatarEditor.hbs
// module id = 681
// module chunks = 0